import request from '@/router/axios';

// 分页查询字典信息   page  size
export const searchDictInfoListByPage = (data) => {
  return request({
    url: '/svolt-ess-boss-service/dictInfo/searchDictInfoListByPage',
    method: 'post',
    data: data
  })
};

// 根据字典ID获取字典选项列表   dictInfoId
export const searchDictOptionListByDictInfoId = (data) => {
  return request({
    url: '/svolt-ess-boss-service/dictInfo/searchDictOptionListByDictInfoId',
    method: 'get',
    params: data
  })
};

// 新增字典   dictName
export const addDictInfo = (data) => {
  return request({
    url: '/svolt-ess-boss-service/dictInfo/addDictInfo',
    method: 'post',
    data: data
  })
};

// 新增字典选项   dictInfoId、optionName
export const addDictOption = (data) => {
  return request({
    url: '/svolt-ess-boss-service/dictInfo/addDictOption',
    method: 'post',
    data: data
  })
};

// 启用-禁用字典  dictStatus  id
export const enableOrDisableDict = (data) => {
  return request({
    url: '/svolt-ess-boss-service/dictInfo/enableOrDisableDict',
    method: 'post',
    data: data
  })
};

// 启用-禁用字典选项    status    id
export const enableOrDisableDictOption = (data) => {
  return request({
    url: '/svolt-ess-boss-service/dictInfo/enableOrDisableDictOption',
    method: 'post',
    data: data
  })
};

// 修改字典选项    optionName    id
export const updateDictOption = (data) => {
  return request({
    url: '/svolt-ess-boss-service/dictInfo/updateDictOption',
    method: 'post',
    data: data
  })
};

export default {
  searchDictInfoListByPage,
  searchDictOptionListByDictInfoId,
  addDictInfo,
  addDictOption,
  enableOrDisableDict,
  enableOrDisableDictOption,
  updateDictOption
}



// WEBPACK FOOTER //
// ./src/api/dataDictionary.js